import { dateFns, Iso } from 'iso-fns2'

type Period = {
  startDate: Iso.Date
  numberOfMonths: number
}

export function overlap(periodA: Period, periodB: Period) {
  const startA = periodA.startDate
  const startB = periodB.startDate

  if (!startA || !startB) return false

  const endA = dateFns.add(periodA.startDate, { months: periodA.numberOfMonths })
  const endB = dateFns.add(periodB.startDate, { months: periodB.numberOfMonths })

  return (startA <= endB && endA >= startB) || (startB <= endA && endB >= startA)
}

export function getRowIndicesWithValue(matrix: (number | null)[][]) {
  return matrix.reduce((acc, row, i) => {
    const values = row.filter((r) => r !== null) as number[]
    if (values.length > 0) {
      return [...acc, i]
    } else {
      return acc
    }
  }, []) as number[]
}

export function getColumnIndicesWithValue(matrix: (number | null)[][]) {
  return matrix.reduce(
    (acc, row) =>
      row.reduce((rAcc, value, month) => {
        if (value && !acc.includes(month + 1)) {
          return [...rAcc, month + 1]
        }
        return rAcc
      }, acc),
    []
  ) as number[]
}

export function indexIntoMatrix(matrix: (number | null)[][], rowIndex: number, colIndex: number) {
  if (rowIndex >= 0 && rowIndex < matrix.length && colIndex < matrix[rowIndex].length) {
    const price = matrix[rowIndex][colIndex]
    return price || null
  } else {
    return null
  }
}

export function roundUSDToCents(amount: number): number {
  return Number(amount.toFixed(2))
}

export function findClosestInList(list: number[], target: number) {
  list.sort((a, b) => {
    return Math.abs(target - a) - Math.abs(target - b)
  })
  return list[0]
}
